

















































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { SearchItemType, TableColumnItemType, OperationItemType, OptionItemType } from '../../../types/type'
import { Pagination } from '../../../mixins/pagination'
import Store, { CommonModule, UserModule } from '../../../store'
import { disposeSearchParamsForCM, getArrChildForTree, findItemForTree, getNameTextInOptions, getSuffix } from '../../../utils/toolsForCommon'
import axios from 'axios'
import { encode } from 'js-base64'
@Component({
  name: 'CapitalApplicationAuditForAppropriation',
  mixins: [Pagination],
  components: {
    'search-module': () => import('../../../components/common/searchModule.vue'),
    'table-module': () => import('../../../components/common/tableModule.vue'),
    'my-dialog': () => import('../../../components/common/myDialog.vue'),
    'application-container-table': () => import('../../../components/applicationContainerTable/index.vue'),
    'loading-container': () => import('../../../components/loading.vue')
  }
})
export default class CapitalApplicationAuditForAppropriation extends Vue {
  public loading = false
  public filterText: string = ''
  // 搜索条件的最终选中项：
  public searchCheckList: Array<string> = []
  // 所有搜索条件：
  public searchList: Array<SearchItemType> = [
    {
      title: '日期',
      key: 'dateInterval',
      type: 'dateForDaterange',
      value: '',
      placeholder: '请选择日期',
      show: true,
      disabled: false
    },
    {
      title: '食堂专户账号',
      key: 'account',
      type: 'input',
      value: '',
      placeholder: '请输入食堂专户账号',
      show: true,
      disabled: false
    },
    {
      title: '开户行',
      key: 'depositBank',
      type: 'input',
      value: '',
      placeholder: '请输入开户行',
      show: true,
      disabled: false
    }
  ]
  // 列表列有哪些：
  public tableColumnList: Array<TableColumnItemType> = [
    {
      title: '编号',
      key: 'uniqueCode',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '280px'
    },
    {
      title: '处理进度',
      key: 'status',
      type: 'tag',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    },
    {
      title: '乡镇',
      key: 'townName',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    },
    {
      title: '学校',
      key: 'schoolName',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    },
    {
      title: '食堂专户名称',
      key: 'accountName',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '150px'
    },
    {
      title: '食堂专户账号',
      key: 'account',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '150px'
    },
    {
      title: '开户行',
      key: 'depositBank',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '150px'
    },
    {
      title: '开户行号',
      key: 'depositBankCode',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    },
    {
      title: '申请资金金额（元）',
      key: 'applyAmount',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '150px'
    },
    {
      title: '申请事由',
      key: 'applyReason',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '250px'
    },
    {
      title: '申请时间',
      key: 'time',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    },
    {
      title: '资金拨付时间',
      key: 'appropriateTime',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    }
  ]
  // 列表每一行的操作有哪些：
  public columnOperationList: Array<OperationItemType> = [
    {
      title: '详情',
      key: 'detail',
      type: 'primary',
      size: 'mini'
    },
    {
      title: '拨付',
      key: 'passForCapitalApplicationAuditForAppropriationOfCityInvestment',
      type: 'success',
      size: 'mini'
    },
    {
      title: '审批记录(有驳回)',
      key: 'failForbackOfCapitalApplication',
      type: 'danger',
      size: 'mini'
    },
    {
      title: '退回',
      key: 'sendBackForCapitalApplicationAuditForAppropriationOfCityInvestment',
      type: 'danger',
      size: 'mini'
    }
  ]
  // 列头操作：
  public operationForButtonOfTableHeader: Array<OperationItemType> = [
    {
      title: "<span class='el-icon-bottom'></span>导出资金拨付审核列表",
      key: 'exportExcel',
      type: 'primary',
      size: '',
      canExportOutFlag: true,
      titleCopy: "<span class='el-icon-bottom'></span>导出资金拨付审核列表",
      exportResultFileName: '资金拨付审核列表.xlsx',
      exportLoading: "<span class='el-icon-loading'></span>正在导出中，请稍后",
      exportError: '抱歉，导出失败',
      exportSuccess: '导出成功'
    }
  ]
  public whoUploadForItem: OperationItemType | null = null
  public dialogFlagForApplyDetail: boolean = false
  // 申请表的详细信息：
  public detailInfo: any = {}
  public loadingForApplyDetail: boolean = false
  // 枚举选项：
  // 处理进度：
  public optionsForAuditStatus: Array<OptionItemType> = [
    {
      name: '中心学校待审批',
      value: 1
    },
    {
      name: '后勤待审批',
      value: 2
    },
    {
      name: '中心学校驳回',
      value: 3
    },
    {
      name: '城投待审批',
      value: 4
    },
    {
      name: '后勤驳回',
      value: 5
    },
    {
      name: '城投待打款',
      value: 6
    },
    {
      name: '城投审核驳回',
      value: 7
    },
    {
      name: '城投转账驳回',
      value: 8
    },
    {
      name: '学校待确认',
      value: 9
    },
    {
      name: '已完成',
      value: 10
    }
  ]
  public optionsForAuditStatusForTagType: Array<OptionItemType> = [
    {
      name: '',
      value: 1
    },
    {
      name: '',
      value: 2
    },
    {
      name: 'danger',
      value: 3
    },
    {
      name: '',
      value: 4
    },
    {
      name: 'danger',
      value: 5
    },
    {
      name: '',
      value: 6
    },
    {
      name: 'danger',
      value: 7
    },
    {
      name: 'danger',
      value: 8
    },
    {
      name: 'success',
      value: 9
    },
    {
      name: 'success',
      value: 10
    }
  ]
  // 上传拨付证明相关：
  public dialogFlagForUploadFile :boolean = false
  public loadingForUploadFile: boolean = false
  public transferFile: string = ''
  public passIds: Array<string | number> = []
  // 附件预览：
  public dialogVisibleForPreviewFile: boolean = false
  public dialogVisiblePreviewUrl: string = ''
  public dialogVisibleiframeShowFlag: boolean = false
  // 退回弹框相关：
  public dialogFlagForBack: boolean = false
  public loadingForBack: boolean = false
  public reasonForBack: string = ''
  public idListForBack: Array<string | number> = []
  // 查看驳回详情：
  public visibleForFailBackDetailList: boolean = false
  public failBackDetailList: Array<any> = []
  public loadingForFailBackDetailList: boolean = false

  get treeDataForSubOrganatizion () {
    return CommonModule.treeDataForSubOrganatizion
  }

  get treeDataForOrganatizion () {
    return CommonModule.treeDataForOrganatizion
  }

  get userInfo () {
    return UserModule.userInfo
  }

  get orgName (): string {
    const org = findItemForTree(this.treeDataForSubOrganatizion, 'children', 'id', this.userInfo.organizationId)
    return org && org['name'] ? org['name'] : '- -'
  }

  @Watch('filterText') filterTextChange (val: any) {
    ;(this.$refs.tree as any).filter(val)
  }

  async mounted () {
    await Promise.all([
      CommonModule.getTreeDataForSubOrganization()
    ])
    this.disposeSearchCheckedInit()
    this.disposeForSearchList()
    this.$nextTick(() => {
      ;(this as any).$refs.tree.setCheckedKeys(getArrChildForTree(this.treeDataForSubOrganatizion, 'children').map(item => item.id))
      this.getTableDataList()
    })
  }

  // 选择项初始化：
  disposeSearchCheckedInit () {
    // this.searchCheckList = this.searchList.length > 2 ? this.searchList.slice(0, 2).map(item => item.key) : this.searchList.slice(0).map(item => item.key)
    this.searchCheckList = this.searchList.slice(0).map(item => item.key)
  }

  // 选择项数据处理：
  disposeForSearchList () {
    this.searchList = this.searchList.map(item => {
      const { key } = item
      switch (key) {
      }
      return item
    })
  }

  // 操作按钮：
  operationForButton ({ key }, row, uploadFile?: File) {
    switch (key) {
      case 'detail':
        this.dialogFlagForApplyDetail = true
        this.detailInfo = row
        break
      case 'passForCapitalApplicationAuditForAppropriationOfCityInvestment':
        this.operationForDisposeTheApply([row.id], 1, '确定要对此资金申请进行拨付吗？')
        break
      case 'failForbackOfCapitalApplication':
        this.visibleForFailBackDetailList = true
        this.getFailBackDetail(row.id)
        break
      case 'sendBackForCapitalApplicationAuditForAppropriationOfCityInvestment':
        // old:
        // this.operationForDisposeTheApply([row.id], 0, '确定要对此资金申请进行退回吗？')
        // 现在需要有退回理由，采用弹框：
        this.dialogFlagForBack = true
        this.idListForBack = [row.id]
        break
      case 'exportExcel':
        // 开始导出：
        this.operationForButtonOfTableHeader.forEach(async item => {
          if (item.key === 'exportExcel') {
            if (!item.canExportOutFlag) return this.$message.error('请等待上一次请求完成！')
            item.canExportOutFlag = false
            item.title = item.exportLoading
            const searchParams = disposeSearchParamsForCM(this.searchList, this.searchCheckList)
            const params = {
              ...searchParams,
              schoolIds: (this as any).$refs.tree.getCheckedKeys(true),
              role: 'URBAN_INVESTMENT_TRANSFER',
              completed: 0
            }
            const result = await (this as any).$http.capitalAppExport(params)
            if (result.status !== 200) {
              this.$message.error(item.exportError)
              item.canExportOutFlag = true
              item.title = item.titleCopy
              return false
            };
            const blob = new Blob([result.data], {
              type: 'application/vnd.ms-excel'
            })
            const objectUrl = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = objectUrl
            a.download = this.orgName + '--' + item.exportResultFileName
            a.click()
            // 释放临时的对象url
            window.URL.revokeObjectURL(objectUrl)
            this.$message.success(item.exportSuccess)
            item.canExportOutFlag = true
            item.title = item.titleCopy
          }
        })
        break
    }
  }

  async getFailBackDetail (id) {
    try {
      this.failBackDetailList = []
      this.loadingForFailBackDetailList = true
      const params = {
        auditScene: 3, // 1:会计凭证审核;2:资金转账记录;3:资金使用申请
        id
      }
      const { data: result } = await (this as any).$http.getLogAudit(params)
      this.loadingForFailBackDetailList = false
      if (result.code !== 200) return this.$message.error(result.msg)
      this.failBackDetailList = (result.data || []).map(item => {
        let res = ''
        const NodeRes = findItemForTree(this.treeDataForOrganatizion, 'children', 'id', item['operatorOrg'])
        if (!Object.keys(NodeRes).length) {
          res = '- -'
        } else {
          res = NodeRes['name']
        }
        item.description = `
          ${item.audit ? '通过' : '驳回'}
          ----
          ${res}
          组织节点的用户（
          ${item['operatorName']}
          ）在
          ${item['time']}
          进行处理，处理完的状态为：
          ${getNameTextInOptions(this.optionsForAuditStatus, item['resultStatus'])}
          ，处理原因为：
          ${item['reason'] ? item['reason'] : '- -'}
        `
        return item
      })
    } catch (err) {
      console.log(err)
    }
  }

  // 处理申请 ：
  operationForDisposeTheApply (ids: Array<string | number>, operation: number, confirmText: string) {
    let messageText = ''
    // 0表示驳回，1表示通过（打款）
    switch (operation) {
      case 0:
        messageText = '操作成功，已退回'
        break
      case 1:
        messageText = '操作成功，已拨付'
        break
    }
    this.$confirm(confirmText, '提示', {
      confirmButtonText: `确定${operation ? '拨付' : '退回'}`,
      cancelButtonText: `取消${operation ? '拨付' : '退回'}`,
      type: 'warning'
    }).then(async () => {
      // 如果是拨付还需要上传附件：
      if (operation) {
        this.passIds = ids
        this.dialogFlagForUploadFile = true
      } else {
        // 如果是退回则正常走：
        let { data: result } = await (this as any).$http.capitalAppApprove({
          ids,
          operation,
          role: 'URBAN_INVESTMENT_TRANSFER'
        })
        if (result.code !== 200) return this.$message.error(result.msg)
        this.$message.success(messageText)
        this.getTableDataList()
      }
    }).catch(() => {})
  }

  operationForConfirmUploadFileForApply () {
    try {
      const cb = async () => {
        let { data: result } = await (this as any).$http.capitalAppApprove({
          ids: this.passIds,
          operation: 1,
          role: 'URBAN_INVESTMENT_TRANSFER',
          file: this.transferFile
        })
        if (result.code !== 200) return this.$message.error(result.msg)
        this.$message.success('操作成功，已拨付')
        this.getTableDataList()
        this.dialogFlagForUploadFile = false
        this.transferFile = ''
      }
      if (!this.transferFile) {
        this.$confirm('您暂未上传资金拨付证明，请问要继续吗', '提示', {
          confirmButtonText: `继续`,
          cancelButtonText: `取消`,
          type: 'warning'
        }).then(async () => {
          cb()
        }).catch(() => {})
      } else {
        cb()
      }
    } catch (err) {
      console.log(err)
    }
  }

  mySelfUploadForTransferFile (param) {
    this.mySelfUploadFile(param, 'transferFile')
  }

  async mySelfUploadFile (param, who) {
    const _that = this
    const params = {
      contentType: param.file.type,
      suffix: getSuffix(param.file.name)
    }
    this.loadingForUploadFile = true
    const { data: result } = await (this as any).$http.uploadFile(params)
    if (result.code !== 200) return this.$message.error(result.msg)
    let reader = new FileReader()
    reader.readAsArrayBuffer(param.file)
    reader.onload = async function () {
      const onloadResult = reader.result
      await axios.put(result.data, onloadResult, {
        headers: {
          'Content-Type': param.file.type,
          authorization: Store.state.User.token
        }
      })
      _that.$message.success('上传成功')
      const url = result.data.split('?')[0]
      const obj = {
        url,
        name: param.file.name
      }
      _that[who] = JSON.stringify(obj)
      _that.loadingForUploadFile = false
    }
  }

  // 预览：
  previewBtn (v) {
    let _that: any = this
    this.dialogVisibleForPreviewFile = true
    let previewUrl = _that.$previewURL + '/onlinePreview?url=' + encodeURIComponent(encode(v))
    this.dialogVisiblePreviewUrl = previewUrl
  }

  // 预览框打开的时候：
  dialogVisibleOpened () {
    let _that: any = this
    _that.dialogVisibleiframeShowFlag = false
    _that.$nextTick(() => {
      let iframeBox = document.querySelector('#iframeBoxOfdialogVisible')
      if ((iframeBox as any).attachEvent) {
        ;(iframeBox as any).attachEvent('onload', function () {
          _that.dialogVisibleiframeShowFlag = true
        })
      } else {
        ;(iframeBox as any).onload = function () {
          _that.dialogVisibleiframeShowFlag = true
        }
      }
      _that.dialogVisibleiframeShowFlag = true
    })
  }

  operationForPassInBatches () {
    if (!(this as any).$refs.refForTableModule.multipleSelection.length) return this.$message.warning('请选择需要通过的项')
    this.operationForDisposeTheApply((this as any).$refs.refForTableModule.multipleSelection.map(item => item.id), 1, '确定要对选中的资金申请进行拨付吗？')
  }

  operationForSendBackInBatches () {
    if (!(this as any).$refs.refForTableModule.multipleSelection.length) return this.$message.warning('请选择需要退回的项')
    // old:
    // this.operationForDisposeTheApply((this as any).$refs.refForTableModule.multipleSelection.map(item => item.id), 0, '确定要对选中的资金申请进行退回吗？')
    // 现在需要有退回理由，采用弹框：
    this.dialogFlagForBack = true
    this.idListForBack = (this as any).$refs.refForTableModule.multipleSelection.map(item => item.id)
  }

  operationForUploadInner (item) {
    this.whoUploadForItem = item
  }

  mySelfUpload (param: File) {
    this.operationForButton(this.whoUploadForItem, {}, param)
  }

  filterNode (value: any, data: any) {
    if (!value) return true
    return data.name.indexOf(value) !== -1
  }

  async getTableDataList () {
    try {
      const _that: any = this
      this.loading = true
      const pageParams = {
        pageNo: _that.currentPage,
        pageSize: _that.pageSize
      }
      const searchParams = disposeSearchParamsForCM(this.searchList, this.searchCheckList)
      const params = {
        ...pageParams,
        ...searchParams,
        schoolIds: (this as any).$refs.tree.getCheckedKeys(true),
        role: 'URBAN_INVESTMENT_TRANSFER',
        completed: 0
      }
      const { data: result } = await (this as any).$http.capitalAppQuery(params)
      this.loading = false
      if (result.code !== 200) return this.$message.error(result.msg)
      _that.tableDataList = ((result.data && result.data.records) || []).map(item => {
        item['tagType'] = getNameTextInOptions(this.optionsForAuditStatusForTagType, item.status)
        item.status = getNameTextInOptions(this.optionsForAuditStatus, item.status)
        return item
      })
      _that.total = result.data.total
    } catch (err) {
      console.log(err)
    }
  }

  resetBtn () {
    this.searchList = this.searchList.map(item => {
      const { key } = item
      switch (key) {
        default:
          item.value = ''
          break
      }
      return item
    })
  }

  searchBtn (searchCheckListSelf) {
    let _that: any = this
    _that.currentPage = 1
    _that.pageSize = 10
    this.searchCheckList = searchCheckListSelf
    this.getTableDataList()
  }

  handleCheckChange (): void {
    this.getTableDataList()
  }

  // 暂时不作限制
  beforeUpload () {}

  async confirmBack () {
    try {
      if (!this.reasonForBack) return this.$message.warning('请输入退回理由')
      this.loadingForBack = true
      // 如果是退回则正常走：
      let { data: result } = await (this as any).$http.capitalAppApprove({
        ids: this.idListForBack,
        operation: 0,
        role: 'URBAN_INVESTMENT_TRANSFER',
        reason: this.reasonForBack
      })
      this.loadingForBack = false
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success('操作成功，已退回')
      this.getTableDataList()
      this.reasonForBack = ''
      this.dialogFlagForBack = false
    } catch (err) {
      console.log(err)
    }
  }
}
